import styled from 'styled-components';
import { Box } from '@components/Box';
import { TextBackgroundPhoto } from '@components/TextBackgroundPhoto';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Columns } from '@components/Columns';

export const StyledMobileLoader = styled.div`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;

export const UniversalRegistryWrapper = styled(Box)<{
  backgroundMobileImg: string;
  isVisible: boolean;
}>`
  position: relative;
  margin-bottom: 130px;
  ${themeMediaQuery('below_sm')} {
    margin-bottom: 0px;
    background: url(${(props) => (props.isVisible ? cloudAssetUrl(props.backgroundMobileImg, { optimization: 'mild' }) : '')});
    background-size: auto;
    background-repeat: no-repeat;
    background-position: 0px top;
    padding-top: 230px;
  }
`;

export const StyledBackgroundPhoto = styled(TextBackgroundPhoto)`
  padding-bottom: 0px;
  box-sizing: border-box;
  ${themeMediaQuery('below_sm')} {
    background-size: contain;
  }
`;

export const HeroTextContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  /* padding-top: ${themeSpace(16)}; */
  padding-top: 40rem;
  ${themeMediaQuery('below_sm')} {
    padding-top: 0rem;
    /* padding-top: ${themeSpace(0)}; */
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    padding-top: 40rem;
  }
  /* padding-top: 10rem;
  ${themeMediaQuery('lg')} {
    padding-top: 20rem;
  } */
`;

export const StyledHeroTextColumn = styled(Columns)`
  ${themeMediaQuery('sm')} {
    /* max-width: 55rem; */
  }
  ${themeMediaQuery('lg')} {
    /* max-width: 90rem; */
  }
`;

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 578px;
    margin-top: 20px;
    margin-bottom: 24px;
    font-size: 55px;
    line-height: 68px;
  }
  .text-pairing-body {
    width: 495px;
    max-width: 495px;
    font-size: 20px;
    line-height: 32px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      font-size: 34px;
      line-height: 46.88px;
    }
    .text-pairing-body {
      width: auto;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 480px;
    }
    .text-pairing-body {
      width: auto;
      max-width: 500px;
    }
  }
`;

export const LottiesContainer = styled(Flex)`
  justify-content: space-between;
  width: calc(100vw / 1.1);
  max-width: 600px;
  ${themeMediaQuery('below_sm')} {
    max-width: 100%;
    width: 100%;
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    display: grid;
    grid-template-columns: 50% 50%;
  }
`;

export const StateIconTextContainer = styled(Flex)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${themeMediaQuery('below_sm')} {
    /* width: 50%; */
    margin-bottom: 30px;
  }
`;

export const StateIconLottie = styled(Flex)`
  width: 64px;
  height: 64px;
  background-color: rgba(117, 156, 255, 0.1);
  border-radius: 50%;
  margin-bottom: 10px;
  justify-content: center;
  align-items: center;
  ${themeMediaQuery('below_sm')} {
    width: 70px;
    height: 70px;
  }
`;

export const IconTextPairing = styled(TextPairing)`
  .text-pairing-title {
    ${themeMediaQuery('below_sm')} {
      font-size: 14px;
    }
  }
`;
